export default {
  name: 'end',
  data: function() {
    return {
      linkAddress: 'groheondus://guard/installation/finished/',
      showEmailInput: false,
      validMail: true,
      validManuelMail: true
    }
  },
  props: ['installGuideID', 'dl_link', 'email', 'landingText', 'errorMessage'],
  watch: {
    showEmailInput: function() {
      this.email.send_via_email = this.showEmailInput
    }
  },
  computed: {
    landingCompoment: function() {
      return this.$store.getters.langFile.landing
    }
  },
  methods: {
    sendEmail: function() {
      if (this.email.send_via_email === false) {
        return
      }
      let data = {
        email_address: this.email.email_address,
        language: this.$route.params.id,
        pdf_link: {
          installation_id: this.installGuideID,
          dl_link: this.dl_link
        }
      }
      this.$http.post('email', data)
        .then(response => {
          if (response && response.body && response.body.installation_id) {
            console.log('/email', response.body)
          }
        })
      // error callback
        .catch(err => {
          this.errorMessage = true
          console.log('Error:', err)
        })
    },
    validEmail: function() {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.validMail = re.test(this.email.email_address)
    },
    validManuelEmail: function() {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.validManuelMail = re.test(this.installer.email)
    },
    goTo: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'connect',
        params: {
          id
        }
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/plan/subComponents/end/end.js